/** The Running order teaching view's words. */
export const TEACH_COPY = {
  enter: "Teaching view",
  leave: "Leave teaching view",
  position: (at: number, of: number) => `Activity ${at} of ${of}`,
  previous: "Previous activity",
  next: "Next activity",
  select: "Activity",
  list: "Activities in order",
  noPrompt: "No prompt written for this activity.",
  private: "Teaching team only",
  none: "No activities planned yet. Add the first one to teach from it.",
  removed: "The activity you were teaching from was removed from the running order.",
  first: "Teach from the first activity",
  change: "Change this activity",
  reference: { reading: "Reading", material: "Material", assignment: "Coursework" },
  open: { reading: "Open reading", material: "Open material", assignment: "Open coursework" },
  unavailable: "This activity's reference is no longer available.",
  coursework: "Coursework from this activity",
  continue: "Continue draft",
  choose: "Continue a draft",
  create: "Create coursework",
  another: "Create another coursework",
  unsaved: "Coursework begins from a saved activity. The plan saves this activity first.",
  remove: "Remove from activity",
  removing: "Removing...",
  removeFailed: "Couldn't remove it from the activity.",
  removeUnknown: "The removal wasn't confirmed. Check sends the same request again.",
  check: "Check",
  removeNote: "Removes only the link. The coursework stays as it is.",
  status: { draft: "Not published", published: "Published", closed: "Closed", archived: "Archived" },
  savedBy: (when: string) => `Saved ${when}`,
} as const;
